{
	"accounts": "Comptes",
	"addAccount": "Ajouter un compte",
	"exportExcel": "Exporter vers Excel",
	"importExcel": "Importer vers Excel",
	"payable": "payable",
	"receivable": "Recevable",
	"emptyText": "Aucun compte trouvé",
	"isPaidYes": "Oui",
	"isPaidNo": "Non",
	"paymentStatus": {
		"All": "Tous",
		"Paid": "Payé",
		"NotPaid": "Non payé"
	},
	"buttonActions": {
		"markAsPaid": "Marquer comme payé",
		"unMarkAsPaid": "Démarquer comme payé",
		"markAsReceived": "Marquer comme reçu",
		"unMarkAsReceived": "Démarquer comme reçu",
		"viewDetails": "Voir les détails",
		"viewEdit": "Voir/Modifier"
	},
	"clearAllFilters": "Effacer tous les filtres",
	"clearAllFiltersTooltip": "Supprime tous les filtres appliqués et revient à la vue par défaut",
	"status": {
		"all": "Tous",
		"payabled": "Payé",
		"recivabled": "Reçu",
		"late": "En retard",
		"conciliated": "Concilié",
		"payablePending": "À payer",
		"receivablePending": "À recevoir",
		"payableToday": "Payer aujourd'hui",
		"receivableToday": "Recevoir aujourd'hui"
	},
	"titleAccountPayable": "Comptes à payer",
	"excelFileNamePayable": "comptes_à_payer",
	"titleAccountReceivable": "Factures à recevoir",
	"excelFileNameReceivable": "factures_à_recevoir",
	"form": {
		"newAccountPayable": "Nouveau compte à payer",
		"editAccountPayable": "Modifier le compte fournisseur",
		"newAccountReceivable": "Nouveau compte à recevoir",
		"editAccountReceivable": "Modifier le compte à recevoir",
		"informOfPayments": "Informations de paiement",
		"postingInformation": "Informations sur la publication",
		"lblSupplier": "Fournisseur",
		"phSupplier": "Sélectionner le fournisseur",
		"lblDocNumber": "Numéro du document",
		"phDocNumber": "Insérer le numéro du document",
		"lblInvoiceDate": "Date d'exercice",
		"phInvoiceDate": "Sélectionner la date d'acquisition",
		"lblPaymentDate": "Date de paiement",
		"phPaymentDate": "Sélectionner la date de paiement",
		"lblDueDate": "Date d'échéance",
		"phDueDate": "Sélectionner la date d'échéance",
		"lblDescription": "Description",
		"phDescription": "Insérer une description",
		"phValue": "Insérer une valeur",
		"lblValue": "Valeur",
		"lblPaymentMethod": "Méthode de paiement",
		"phPaymentMethod": "Sélectionner le mode de paiement",
		"lblAccountId": "Compte bancaire",
		"phAccountId": "Sélectionner un compte bancaire",
		"lblCostCenter": "Centre de coûts",
		"phCostCenter": "Sélectionner un centre de coûts",
		"lblChartAccounts": "Plan comptable",
		"phChartAccounts": "Sélectionner un plan comptable",
		"ttRequiredWhenFilled": "Lors du remplissage du champ valeur, le plan comptable devient obligatoire.",
		"lblInterest": "Intérêts moratoires",
		"phInterest": "Sélectionner les intérêts de retard",
		"lblFine": "Retarder l'amende",
		"phFine": "Sélectionner les frais de retard",
		"lblDiscount": "Remises",
		"phDiscount": "Sélectionner les remises",
		"lblPaidValue": "Montant payé",
		"phPaidValue": "Sélectionner le montant payé",
		"phZeroValue": "0,00",
		"swtIsPaid": "Payé",
		"swtConciliated": "Réconcilié",
		"swtTotalValue": "Valeur totale:",
		"recurringPayment": "Paiement récurrent",
		"lblRecurringPaymentInterval": "Répéter chaque",
		"phRecurringPaymentInterval": "Entrer l'intervalle",
		"oneTime": "Une fois",
		"recurring": "Récurrent",
		"installment": "Valeur échelonnée",
		"lblInstallmentCount": "Nombre d'échéances",
		"phInstallmentCount": "Saisissez le nombre d'échéances",
		"lblInstallmentInterval": "Répéter tous les",
		"phInstallmentInterval": "Saisissez l'intervalle",
		"lblInstallmentTypeInterval": "Intervalle",
		"phInstallmentTypeInterval": "Sélectionnez le type d'intervalle",
		"installmentSummary": "Valeur totale de {{total}} répartie en {{count}} échéances",
		"lblInstallmentBetween": "Intervalle entre les échéances",
		"phInstallmentBetween": "Sélectionnez l'intervalle",
		"lblInstallmentFirstDueDate": "Échéance de la première mensualité",
		"lblInstallmentFirstCompetenceDate": "Date de comptabilisation de la première mensualité",
		"installmentPeriodicity": {
			"Day": "Quotidien",
			"Week": "Hebdomadaire",
			"Month": "Mensuel",
			"Year": "Annuel"
		},
		"lblRecurringPaymentTypeInterval": "Intervalle",
		"phRecurringPaymentTypeInterval": "Sélectionner le type d'intervalle",
		"lblRecurringPaymentTimes": "Combien de fois?",
		"phRecurringPaymentTimes": "Entrer le nombre de fois",
		"totalRepetition": "Répétition en ",
		"recurringEnd": "Fin de la récurrence:",
		"observation": "Observation",
		"attachment": "Pièce jointe",
		"lblObservation": "Insérer une observation",
		"lblAttachment": "Cliquez pour joindre des fichiers",
		"lblFinancialFees": "Frais administratifs",
		"phFinancialFees": "Sélectionnez les frais administratifs",
		"validations": {
			"dueDate": "Entrez la date d'échéance pour continuer",
			"value": "Entrez la valeur pour continuer",
			"chartAccounts": "Sélectionnez le plan comptable pour continuer",
			"discountGreaterThanBill": "Le remise ne peut pas être supérieure à la valeur de la facture",
			"recurringPaymentInterval": "Entrez l'intervalle de paiement récurrent",
			"recurringPaymentTypeInterval": "Sélectionnez le type d'intervalle de paiement récurrent",
			"recurringPaymentTimes": "Entrez le nombre de fois du paiement récurrent",
			"recurringPaymentTimesMax": "Le nombre maximum de récurrences autorisé est 48",
			"installmentCount": "Saisissez le nombre d'échéances (minimum 2)",
			"installmentCountMax": "Le nombre maximum d'échéances autorisé est 48",
			"installmentInterval": "Saisissez l'intervalle entre les échéances",
			"installmentTypeInterval": "Sélectionnez le type d'intervalle",
			"paymentDate": "Entrez la date de paiement pour continuar",
			"paymentAccount": "Sélectionnez le compte de paiement pour continuer",
			"chartAccountRequired": "Sélectionnez le plan comptable pour continuer"
		},
		"modalDelete": {
			"title": "Supprimer le compte",
			"cancelText": "Annuler",
			"okText": "Supprimer le compte",
			"message": "La suppression du compte est une action finale. Voulez-vous poursuivre la suppression?"
		}
	},
	"columns": {
		"docNumber": "NUMÉRO DE DOCUMENT",
		"supplier": "FOURNISSEUR",
		"chartAccount": "PLAN COMPTABLE",
		"dueDate": "DATE ​​D'ÉCHÉANCE",
		"invoiceDate": "DATE ​​D'ACCEPTATION",
		"paymentDate": "DATE ​​DE PAIEMENT",
		"value": "VALEUR",
		"situation": "SITUATION",
		"paymentMethod": "MODE DE PAIEMENT",
		"actions": "ACTIONS"
	},
	"chartAccounts": "Plan comptable",
	"placeholderChartAccounts": "Sélectionner un plan comptable",
	"labelFilter": "Cliquez pour filtrer",
	"selectSupplier": "Filtrer par fournisseur",
	"lblDocNumber": "Filtrer par numéro de document",
	"phDocNumber": "Entrez le numéro à filtrer",
	"lblPaymentDate": "Filtrer par date de paiement",
	"lblPaymentStatus": "Filtrer par statut de paiement",
	"optPaymentStatusAll": "Tous",
	"optPaymentStatusPaid": "Payés",
	"optPaymentStatusNotPaid": "Non payés",
	"optReceivabledStatus": "Reçus",
	"optNotReceivabledStatus": "Non reçus",
	"lblDueDate": "Filtrer par date d'échéance",
	"lblInvoiceDate": "Filtrer par date de régularisation",
	"tzReceived": "Reçus",
	"tzRecivabledToday": "Recevoir aujourd'hui",
	"tzmaturing": "Payer aujourd'hui",
	"tzDue": "À échéance",
	"tzDelayed": "Retardés",
	"tzPaid": "Payé",
	"tzTotal": "Total de la période",
	"attatchmentDescription": "Joignez les reçus de paiement ou autres documents liés à ce compte afin de ne pas en perdre la trace. Jusqu'à 4 documents sont autorisés aux formats PDF, OFX, XML, XLS, JPG et PNG jusqu'à 5 Mo.",
	"attachFile": "Cliquez pour joindre un fichier",
	"attachImportError": {
		"existingFile": "Fichier déjà importé",
		"exceededSize": "Limite de taille dépassée. La pièce jointe ne doit pas dépasser 5 Mo"
	},
	"attachModal": {
		"title": "Pièces jointes au compte",
		"noAttachments": "Aucune pièce jointe trouvée pour le moment",
		"table": {
			"columns": {
				"attachedFiles": "Fichiers joints"
			},
			"successfullyDeletedFile": "Fichier supprimé",
			"errorDeleted": "Impossible de supprimer le fichier"
		}
	},
	"attachedToChartAccountsModal": {
		"linksPlural": "{{chartAccounts}} links",
		"linksSingular": "1 link",
		"seeLinks": "Voir les links",
		"title": "Lien avec le plan comptable",
		"description": "Enregistrer la relation à laquelle cet article renvoie"
	},
	"modalPayment": {
		"title": "Marquer comme payé",
		"titleReceivable": "Marquer comme reçu",
		"paymentMethod": "Méthode de paiement",
		"selectPaymentMethod": "Sélectionner la méthode de paiement",
		"interests": "Intérêts par retard",
		"fine": "Multa par retard",
		"discount": "Remises",
		"financialFees": "Frais administratifs",
		"description": "Sélectionnez la date du paiement et le compte bancaire dans lequel vous souhaitez enregistrer le paiement",
		"descriptionReceivable": "Sélectionnez la date de réception et le compte bancaire dans lequel vous souhaitez enregistrer la réception",
		"paymentDate": "Date de paiement",
		"receiptDate": "Date de réception",
		"paymentAccount": "Compte bancaire",
		"selectAccount": "Sélectionner un compte bancaire",
		"required": "Veuillez sélectionner une date de paiement",
		"cancel": "Annuler",
		"confirm": "Confirmer",
		"addAccount": "Ajouter un compte",
		"deletedAccount": "Compte supprimé",
		"placeholderChartOfAccounts": "Sélectionner un plan comptable",
		"placeholderZeroValue": "0,00",
		"errors": {
			"paymentDate": {
				"required": "Date de paiement est obligatoire",
				"invalid": "Format de date invalide",
				"future": "La date ne peut pas être postérieure à la date d'ouverture de l'enregistrement"
			},
			"paymentAccount": {
				"required": "Compte bancaire est obligatoire"
			},
			"requiredChartOfAccounts": "Sélectionnez un plan comptable",
			"requiredValue": "Entrez la valeur",
			"discountGreaterThanBill": "Le remise ne peut pas être supérieure à la valeur de la facture"
		}
	},
	"startDate": "Date de début",
	"endDate": "Date de fin",
	"drawer": {
		"titlePayable": "Compte à payer",
		"titleReceivable": "Compte à recevoir",
		"titlePayableEdit": "Modifier compte à payer",
		"titleReceivableEdit": "Modifier compte à recevoir",
		"titlePayableView": "Visualiser compte à payer",
		"titleReceivableView": "Visualiser compte à recevoir",
		"tabs": {
			"launch": "Enregistrement",
			"attachments": "Pièces jointes",
			"recurrencesSummary": "Résumé des récurrences",
			"editHistory": "Historique des modifications",
			"installment": "Échéance",
			"installmentPaid": "Enregistrement",
			"installmentSummary": "Résumé total de l'enregistrement",
			"installmentSummaryPaid": "Résumé du paiement"
		},
		"sections": {
			"generalInfo": "Informations générales",
			"details": "Détails"
		},
		"attachments": {
			"dropTitle": "Glissez et déposez les fichiers ici",
			"dropSelect": "ou sélectionnez des fichiers",
			"allowedFormats": "Jusqu'à 4 documents autorisés aux formats PDF, OFX, XML, XLS, JPG et PNG jusqu'à 1.5 Mo.",
			"of": "sur",
			"filesLabel": "fichiers"
		},
		"markAsPaid": "Payé?",
		"markAsReceived": "Reçu?",
		"lblReceiptDate": "Date de réception",
		"phReceiptDate": "Sélectionner date de réception",
		"errors": {
			"paymentDate": {
				"future": "La date ne peut pas être postérieure à la date d'ouverture de l'enregistrement"
			}
		},
		"footer": {
			"totalValue": "Valeur totale:",
			"submit": "Enregistrer",
			"submitUpdate": "Enregistrer les modifications",
			"badgeAVista": "COMPTANT",
			"badgeRecorrente": "RÉCURRENT",
			"recurringWillLaunch": "Seront lancées",
			"recurringRecurrencesOf": "récurrences de",
			"recurringEvery": "tous les",
			"installmentSplitIn": "réparti en",
			"installmentTimesEvery": "fois tous les",
			"installmentParcelValue": "Valeur de l'échéance",
			"installmentTotalOf": "Valeur totale de",
			"installmentDividedIn": "divisé en",
			"installmentParcelsWord": "échéances"
		},
		"tooltips": {
			"recurring": "Créez automatiquement des enregistrements répétés à une fréquence définie.",
			"installmentNotRecurring": "Une écriture échelonnée ne peut pas être récurrente.",
			"markAsPaid": "Marquez l'enregistrement comme payé et fournissez les détails du paiement.",
			"markAsReceived": "Marquez l'enregistrement comme reçu et fournissez les détails de la réception."
		},
		"recurrencesSummary": {
			"emptyText": "Aucune récurrence trouvée.",
			"distributionTitle": "Distribution des récurrences",
			"columns": {
				"sequence": "Échéance",
				"dueDate": "Date d'échéance",
				"finalValue": "Valeur finale",
				"status": "Statut"
			}
		},
		"installmentSummary": {
			"summaryTitle": "Résumé de l'enregistrement",
			"totalValue": "Valeur",
			"type": "Type",
			"typeInstallment": "Valeur échelonnée",
			"typeAVista": "Valeur comptant",
			"quitButton": "Régler toutes les échéances",
			"numberOfInstallments": "Nombre d'échéances",
			"firstDueDate": "Date d'échéance",
			"interval": "Intervalle entre les échéances",
			"distributionTitle": "Répartition des échéances",
			"emptyText": "Aucune échéance trouvée.",
			"hasCharges": "Échéance avec intérêts, pénalité ou remise",
			"totalizerTotalAmount": "Valeur totale des échéances",
			"totalizerInterest": "Total des intérêts payés",
			"totalizerFine": "Total des pénalités payées",
			"totalizerDiscount": "Total des remises obtenues",
			"totalizerPaid": "Valeur totale payée à ce jour",
			"blockedBanner": "Impossible de modifier cette écriture car des échéances sont déjà payées."
		},
		"editHistory": {
			"tabLabel": "Historique des modifications",
			"emptyText": "Aucune modification enregistrée.",
			"installmentTag": "Échéance {{number}}/{{total}}",
			"columns": {
				"action": "Action",
				"user": "Utilisateur",
				"dateTime": "Date et heure"
			},
			"user": {
				"system": "Système"
			},
			"fields": {
				"valor": "valeur",
				"valorDaParcela": "montant de l’échéance",
				"juros": "intérêts de retard",
				"multa": "pénalité de retard",
				"desconto": "remise",
				"taxasAdministrativas": "frais administratifs",
				"valorPago": "valeur payée",
				"valorRecebido": "valeur reçue",
				"dataDeVencimento": "date d'échéance",
				"dataDeCompetencia": "date de compétence",
				"dataDePagamento": "date de paiement",
				"dataDeRecebimento": "date de réception",
				"formaDePagamento": "moyen de paiement",
				"formaDeRecebimento": "moyen de réception",
				"contaBancaria": "compte bancaire",
				"fornecedor": "fournisseur",
				"numeroDoDocumento": "numéro de document",
				"descricao": "description",
				"observacao": "observation",
				"statusDePagamento": "statut de paiement",
				"statusDeRecebimento": "statut de réception",
				"conciliacao": "rapprochement",
				"planoDeContas": "plan comptable"
			},
			"badges": {
				"created": "Écriture créée",
				"paymentAdded": "Marqué comme payé",
				"paymentAddedReceivable": "Marqué comme reçu",
				"reconciled": "Rapproché",
				"deleted": "Écriture supprimée",
				"unknown": "Écriture mise à jour"
			},
			"events": {
				"updatedTo": "{{field}} défini sur {{toValue}}"
			}
		},
		"modalDeleteInstallment": {
			"title": "Supprimer l’écriture échelonnée ?",
			"message": "Les {{total}} échéances seront supprimées. Cette action est irréversible.",
			"messageWithPaid": "Les {{total}} échéances seront supprimées, y compris celles déjà payées — les écritures payées seront annulées du Flux de trésorerie et du compte de résultat (DRE). Cette action est irréversible.",
			"cancelText": "Annuler",
			"okText": "Supprimer"
		}
	},
	"modalSettleInstallments": {
		"title": "Régler toutes les échéances",
		"confirmQuestion": "Voulez-vous vraiment régler ces échéances ?",
		"message": "Vous réglez l'écriture d'un montant de {{total}} répartie en {{count}} échéances.",
		"paymentDate": "Date de paiement",
		"cancel": "Annuler",
		"confirm": "Régler les écritures"
	}
}
